import axios from '@/libs/axios'

export default {

  namespaced: true,

  state: {
    unit: null,
    units: [],
    unitsTotal: 0,
    unitNames: [],
    unitNamesPictures: [],
    unitNamesPackagesPictures: [],
    orderCreatedProduct: null,
  },

  getters: {

    unit(state) {
      return state.unit
    },
    units(state) {
      return state.units
    },
    unitsTotal(state) {
      return state.unitsTotal
    },
    unitNames(state) {
      return state.unitNames
    },
    unitNamesPictures(state) {
      return state.unitNamesPictures
    },
    unitNamesPackagesPictures(state) {
      return state.unitNamesPackagesPictures
    },
  },

  mutations: {

    SET_UNIT(state, value) {
      state.unit = value
    },
    SET_UNITS(state, value) {
      state.units = value
    },
    SET_UNITS_TOTAL(state, value) {
      state.unitsTotal = Number(value) || 0
    },
    SET_UNIT_NAMES(state, value) {
      state.unitNames = value
    },
    SET_UNIT_NAMES_PICTURES(state, value) {
      state.unitNamesPictures = value
    },
    SET_UNIT_NAMES_PACKAGES_PICTURES(state, value) {
      state.unitNamesPackagesPictures = value
    },
    UPDATE_UNITS(state, data) {
      const index = state.units.findIndex(unit => unit.id == data.id)
      if (index === -1) {
        return
      }
      Object.assign(state.units[index], data);
    },
    ADD_UNIT(state, data) {
      state.units.unshift(data);
      state.unitsTotal += 1
    },
    DELETE_UNIT(state, id) {
      const index = state.units.findIndex((unit) => Number(unit.id) === Number(id))
      if (index !== -1) {
        state.units.splice(index, 1)
        if (state.unitsTotal > 0) {
          state.unitsTotal -= 1
        }
      }
    },
    SET_ORDER_CREATED_PRODUCT(state, product) {
      state.orderCreatedProduct = product;
    },
  },

  actions: {

    async loadUnit({ commit }, unitId) {
      try {
        const response = await axios.get(`api/units/${unitId}`);
        commit('SET_UNIT', response.data);
        return response.data;
      } catch (error) {
        console.error('Error loading unit:', error);
        throw error;  // Handle the error if needed
      }
    },
    loadUnits({ commit }, filters = {}) {
      const params = {}
      if (filters.keyword) {
        params.keyword = filters.keyword
      }
      if (filters.unit_category_id) {
        params.unit_category_id = filters.unit_category_id
      }
      if (filters.stock_location_id) {
        params.stock_location_id = filters.stock_location_id
      }
      if (filters.stock_below != null && filters.stock_below !== '') {
        params.stock_below = filters.stock_below
      }
      if (filters.page) {
        params.page = filters.page
      }
      if (filters.per_page) {
        params.per_page = filters.per_page
      }

      return axios.get('api/units', { params }).then(response => {
        const data = response.data.data || []
        const total = Number(response.data.meta?.total ?? data.length)
        commit('SET_UNITS', data)
        commit('SET_UNITS_TOTAL', total)
        return { data, total }
      })
    },
    loadUnitNames({ commit }) {
      return axios.get('api/unit-names').then(response => {
        commit('SET_UNIT_NAMES', response.data)
      })
    },
    loadUnitNamesPictures({ commit }) {
      return axios.get('api/unit-names-pictures').then(response => {
        commit('SET_UNIT_NAMES_PICTURES', response.data.data)
      })
    },
    loadUnitNamesPackagesPictures({ commit }) {
      return axios.get('api/unit-names-packages-pictures').then(response => {
        commit('SET_UNIT_NAMES_PACKAGES_PICTURES', response.data.data)
      })
    },
    updateUnit({ commit }, { formData }) {
      return axios.post(`api/units/${formData.get('id')}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('UPDATE_UNITS', response.data.data)
      })
    },
    async searchUnit({ commit }, { keyword, platformId, forReceive = false }) {

      return await axios.post('api/units/search', {
        keyword,
        platform_id: platformId ?? 0,
        for_receive: forReceive ? 1 : 0,
      }).then((response) => response.data)
    },
    addUnit({ commit }, { formData }) {
      return axios.post(`api/units`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        commit('ADD_UNIT', response.data.data)
        return response.data.data
      })
    },
    syncCustomBarcodes({ commit }, { unitId, barcodes }) {
      return axios.put(`api/units/${unitId}/custom-barcodes`, { barcodes }).then((response) => {
        const saved = response.data?.data
        if (Array.isArray(saved)) {
          commit('UPDATE_UNITS', {
            id: unitId,
            custom_barcodes: saved,
          })
        }
        return response.data
      })
    },
    deleteUnit({ commit }, id) {
      return axios.delete(`api/units/${id}`).then(() => {
        commit('DELETE_UNIT', id)
      })
    },
  },
}
